import { decrypt, encrypt } from './crypt'

export const storeSave = (value, key = 'capacity-2-0-storage') => {
  try {
    window.localStorage.setItem(key, JSON.stringify(value))
  } catch (error) {
    console.error(error)
  }
}

export const storeGet = (key = 'capacity-2-0-storage') => {
  try {
    const storage = window.localStorage.getItem(key)
    return storage === null ? undefined : JSON.parse(storage)
  } catch (error) {
    return undefined
  }
}

export const storeRemove = (key = 'capacity-2-0-storage') => {
  try {
    window.localStorage.removeItem(key)
  } catch (error) {
    console.error(error)
  }
}

export const saveSecureStorage = (state, key = 'rcapacity-2-0-storage') => {
  try {
    const storage = encrypt(state)
    window.localStorage.setItem(key, storage)
  } catch (error) {
    throw new Error(`fail save storage ${error}`)
  }
}

export const getSecureStorage = (key = 'capacity-2-0-storage') => {
  try {
    const storage = window.localStorage.getItem(key)
    return storage === null ? undefined : decrypt(storage)
  } catch (error) {
    return undefined
  }
}
